import { render, staticRenderFns } from "./dashboard-team_cohort.vue?vue&type=template&id=250b5ef3&scoped=true&"
import script from "./dashboard-team_cohort.vue?vue&type=script&lang=js&"
export * from "./dashboard-team_cohort.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "250b5ef3",
  null
  
)

export default component.exports